import { Group } from '../components/interfaces';

export const recursiveTree = (current: string, groups: Group[]): Group[] => {
  const result = [];
  while(current !== null) {
    // eslint-disable-next-line
    const group = groups.find(g => current === g._id);
    if (group) {
      result.push(group);
      current = group.parent;
    }
    else {
      current = null;
    }
  }
  return result.reverse();
}

export const extractRoute = (groups: Group[], prefix = '/', seprator = '/') => {
  if (groups.length === 0) {
    return prefix.replace(/\/$/, '');
  }
  return prefix + groups.map(x => x.name).join(seprator);
}

export const extractRouteById = (pathId: string, groups: Group[], prefix = '/', seprator = '/') => {
  return extractRoute(recursiveTree(pathId, groups), prefix, seprator);
}
